import { IHTTPCompletedResponse } from '@cian/http-api';

import { TThunkAction } from '../../../types/redux';
import { requestRemoveComment, TResponses } from '../../../services/postComments/removeComment';
import { throwError } from '../../../utils';

export const removeComment = (id: number): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;

    try {
      const { responseStatusCode: statusCode }: IHTTPCompletedResponse<TResponses> = await requestRemoveComment({
        httpApi,
        bodyParameters: {},
        queryParameters: {
          id,
        },
        config: {
          browserUrl: config.get<string>('backend-content.browserUrl') || '',
        },
      });

      if (statusCode !== 200) {
        throwError({ message: 'Не удалось удалить комментарий', statusCode, domain: 'actions.removeComment' });

        return false;
      }

      return true;
    } catch (e) {
      logger.error(e, {
        domain: 'actions.removeComment',
      });

      return false;
    }
  };
};
